/* eslint-disable @typescript-eslint/no-explicit-any */
// import Vue from 'vue';
import { extend } from 'vee-validate';
import { required, oneOf, email, required_if } from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/id.json';
// register all available rules
// https://vee-validate.logaretm.com/v3/guide/rules.html#importing-the-rules
// with typescript
// for (const [rule, validation] of Object.entries(rules)) {
//   extend(rule, {
//     ...validation, // copies rule configuration
//     message: (messages as ValidationMessages)[rule], // assign message
//   });
// }
extend('required', {
    ...required,
    message: 'Wajib Diisi',
});
extend('oneOf', {
    ...oneOf,
    message: 'Wajib Diisi',
});
extend('email', {
    ...email,
    message: messages.email,
});
extend('required_if', {
    ...required_if,
    message: messages.required_if,
});
// Register it globally
// Vue.component('ValidationProvider', ValidationProvider);
// Vue.component('ValidationObserver', ValidationObserver);
